import * as z from 'zod/v4';

import { invertObject, zodEnumFromObjectKeys } from '../utils/entry.js';

/**
 * Event type map, the type of a event
 */
export const EVENT_TYPE_VARIANTS = {
  EVENT_1X2: 1,
  HALFTIME_FULLTIME: 2,
  RESULT: 3,
  OVER_UNDER: 4,
  DOUBLECHANCE: 5,
  HANDICAP: 6,
  WINNER: 7,
  FIRST_GOAL_SCORER: 8,
  DUEL: 9,
  PLACING: 10,
  FORECAST: 11,
  HEAD_TO_HEAD: 12,
  LAST_GOAL_SCORER: 13,
  GOALS_BY_TEAM: 14,
  GOALS_BY_PLAYER: 15,
  AMOUNT: 16,
  PENALTY_GOALS: 18,
  PROFIT_MARGIN: 19,
  ODD_EVEN: 20,
  ALL_COMB_HOLDERS: 21,
  ALL_COMB_PARTICIPANTS: 24,
  GOAL_COUNT: 25,
  FIRST_GOAL: 26,
  LAST_GOAL: 27,
  LEAST_AMOUNT_OF_GOALS: 28,
  WIN_WITH_ZEROING: 29,
  EVENT_1X2_OVER_UNDER: 30,
  EVENT_1_2: 31,
  SCORECAST: 32,
} as const;

/**
 * Zod enum for Event type id, the type of a event
 */
export const eventTypeIdEnum = z.enum(EVENT_TYPE_VARIANTS);

/**
 * TS Event type id type, the type of a event
 */
export type EventTypeId = z.infer<typeof eventTypeIdEnum>;

/**
 * Zod enum for Event type, the type of a event
 */
export const eventTypeEnum = zodEnumFromObjectKeys(EVENT_TYPE_VARIANTS);

/**
 * TS Event type type, the type of a event
 */
export type EventType = z.infer<typeof eventTypeEnum>;

/**
 * Event type id map, the type of a event
 */
export const EVENT_TYPE_ID_VARIANTS = invertObject<EventType, EventTypeId>(EVENT_TYPE_VARIANTS);

/**
 * Event sub type map, the type of a event
 *
 * NOTE: This is not used right now but if used in the future, we should add more types here.
 */
export const EVENT_SUB_TYPE_VARIANTS = {
  Undefined: 0,
  Fulltime: 2,
};

/**
 * Zod enum for Event sub type id, the type of a event
 */
export const eventSubTypeIdEnum = z.enum(EVENT_SUB_TYPE_VARIANTS);

/**
 * TS Event sub type id type, the type of a event
 */
export type EventSubTypeId = z.infer<typeof eventSubTypeIdEnum>;

/**
 * Zod enum for Event sub type, the type of a event
 */
export const eventSubTypeEnum = zodEnumFromObjectKeys(EVENT_SUB_TYPE_VARIANTS);

/**
 * TS Event sub type type, the type of a event
 */
export type EventSubType = z.infer<typeof eventSubTypeEnum>;

/**
 * Event sub type id map, the type of a event
 */
export const EVENT_SUB_TYPE_ID_VARIANTS = invertObject<EventSubType, EventSubTypeId>(EVENT_SUB_TYPE_VARIANTS);

/**
 * Zod schema for Event type sub id
 */
export const eventSubTypeIdSchema = z.number().transform((value) => {
  return EVENT_SUB_TYPE_ID_VARIANTS[value] ?? 'Undefined';
});

export const eventTypeIdSchema = eventTypeIdEnum.transform((eventTypeId) => EVENT_TYPE_ID_VARIANTS[eventTypeId]);
